import { render, staticRenderFns } from "./DatastoreListTable.vue?vue&type=template&id=60c94d7d"
import script from "./DatastoreListTable.vue?vue&type=script&lang=js"
export * from "./DatastoreListTable.vue?vue&type=script&lang=js"
import style0 from "./DatastoreListTable.vue?vue&type=style&index=0&id=60c94d7d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports